import { PredefinedTokenKey as PredefinedTokenKeyImport, tokenComponentsMap } from './tokenComponentsMap';
import { getObjectKeys } from '../../../../utils';

export type PredefinedTokenKey = PredefinedTokenKeyImport;

const tokenKeys = getObjectKeys(tokenComponentsMap);

export const isTokenKey = (value: unknown): value is PredefinedTokenKey => {
    return value !== undefined && tokenKeys.includes(value as PredefinedTokenKey);
};

export interface Option {
    value: string;
    label: string;
}

export interface Field {
    value: any;
    validators: Record<string, any>;
    notifications: Record<string, any>;
    error: string | null;
    searchable: boolean;
    isDirty: boolean;
    initialValue: string | object;
    id: string;
    name: string;
    desc?: string;
    options?: Option[];
}

export interface Fields {
    isVisible: Field;
    lastModified: Field;

    [key: string]: Field;
}

export interface Token {
    id: PredefinedTokenKey;
    name: string;
    fields: Fields;
    validators: Record<string, any>;
}

export interface Tokens {
    [key: string]: Token;
}

export type UIType = 'text' | 'radio' | 'dropdown' | 'certificate';

// JSON Schema property with UI extensions
export interface JsonSchemaProperty {
    type?: string;
    title?: string;
    description?: string;
    enum?: (string | number)[];
    default?: any;
    minLength?: number;
    maxLength?: number;
    pattern?: string;
    format?: string;
    properties?: Record<string, JsonSchemaProperty>;
    required?: string[];
    'x-ui-type'?: UIType;
    'x-ui-placeholder'?: string;
    'x-ui-secret'?: boolean;
    'x-ui-certificate-name'?: string;
    'x-ui-default'?: unknown;
    'x-ui-options'?: { label: string; value: string | number }[];
    'x-ui-error-message'?: string;
}

export interface JsonSchema {
    type: 'object';
    properties: Record<string, JsonSchemaProperty>;
    required?: string[];
}

export type MfaProviderIntegrationId = number;

export const isMfaProviderIntegrationId = (value: unknown): value is MfaProviderIntegrationId => {
    return typeof value === 'number' && Number.isInteger(value);
};

export type MfaProviderIntegrationConfig = {
    id: MfaProviderIntegrationId;
    name: string;
    displayName: string;
    fields: JsonSchema;
};

export type ExternalMfaProviderConfigValues = Record<string, unknown>;

export type ExternalMfaProviderSettingsValue = {
    name: string;
    values: ExternalMfaProviderConfigValues;
    lastModified: number;
};

export type ExternalMfaProviderSettings = Record<number, ExternalMfaProviderSettingsValue>;

export type TokenKey = PredefinedTokenKey | MfaProviderIntegrationId;
